<template>
  <div class="text-center">
    <v-card scrollable max-width="100%" max-height="80%" dark>
      <v-card-title class="green">
        WhatsApp
        <v-badge v-if="alertaGeneral" color="red" dot></v-badge>

        <v-divider class="mx-4" inset vertical></v-divider>
        <div class="caption">General</div>

        <v-spacer></v-spacer>

        <div v-if="celular">
          <v-row>
            <v-col>
              <v-tooltip color="green" bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-chip v-bind="attrs" v-on="on" @click="copiarTexto(celular)" color="green darken-4">
                    {{ empresa ? empresa + " - " : "N/A - " }} {{ celular }}
                  </v-chip>
                </template>
                <span>Copiar Movil</span>
              </v-tooltip>
            </v-col>
            <v-col>
              <v-tooltip color="green" bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-chip v-bind="attrs" v-on="on" @click="acciones('visto')" color="green darken-4">
                    <v-icon>mdi-check</v-icon>
                  </v-chip>
                </template>
                <span> Marcar como Visto</span>
              </v-tooltip>
            </v-col>
            <v-col>
              <Editar :usuarioLlega="usuarioW" :telefonoLlega="celular" :empresaLlega="empresa"
                :seguimientoLlega="seguimiento" @enviandoCambio="datosActualizar" />
            </v-col>
            <v-col>
              <CrearOportunidadPNatural />
            </v-col>
            <v-col>
              <v-tooltip color="red" bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn @click="acciones('delete')" class="pa-2" color="red" fab x-small v-bind="attrs" v-on="on">
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </template>
                <span>Eliminar Chat</span>
              </v-tooltip>
            </v-col>
          </v-row>
        </div>

        <v-divider class="ml-5" vertical></v-divider>

        <div class="ml-5">
          <v-row>
            <v-col>
              <NuevoUsuario :NombreEmpleado="rolPrueba" @cerrarTienda="listenToMessages('ok')"
                @click="listenToMessages" />
            </v-col>
            <v-col>
              <ConfiguracionWhatsapp @estadoWhatsappFuncion="estadoW" />
            </v-col>
            <v-col>
              <v-btn @click="masivos" class="mx-2" fab x-small color="green" :loading="masivoWhatsapp" disabled>
                <v-icon dark>mdi-fire</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </div>
      </v-card-title>

      <v-divider></v-divider>

      <v-card-text>
        <v-row>
          <v-col cols="4">
            <v-card v-if="switchTiempoReal" scrollable max-width="500px" elevation="0">
              <div class="message-scroll">
                <v-list>
                  <v-list-item-group v-model="selectedItem" color="orange">
                    <v-list-item v-for="(item, index) in items" :key="index">
                      <v-list-item-content>
                        <v-list-item-title class="text-left">
                          <v-icon v-if="item.contenido.seguimiento" text icon x-small color="red">
                            mdi-alert
                          </v-icon>
                          {{ item.contenido.usuario || "Usuario Desconocido" }}
                        </v-list-item-title>
                        <v-list-item-subtitle class="overline">
                          <v-chip class="ma-2" :color="item.contenido.mensajePendiente ? 'red' : 'green'" x-small>
                            {{ item.numero }}
                          </v-chip>
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </div>
            </v-card>
          </v-col>

          <v-divider vertical></v-divider>

          <v-col cols="8">
            <v-card elevation="0" class="mt-5">
              <div class="message-scroll" ref="scrollContainer">
                <v-list-item v-for="(item, index) in historialMensajes" :key="index">
                  <v-list-item-content>
                    <v-list-item-title :class="[colorChat(item.type), 'text-left', 'text-wrap']"
                      v-if="item.body.type === 'button'">
                      <div class="secondary text-no-wrap rounded-pill d-inline pa-1 deep-purple accent-4 white--text">
                        {{ item.body.button.text }}
                      </div>
                    </v-list-item-title>

                    <v-list-item-title :class="[colorChat(item.type), 'text-left', 'text-wrap']"
                      v-else-if="item.body.type === 'sticker'">
                      <img class="rounded-xxl" :src="item.url" contain lazy-src="https://picsum.photos/id/11/10/6"
                        :aspect-ratio="16 / 9" height="150" />
                    </v-list-item-title>

                    <v-list-item-title :class="[colorChat(item.type), 'text-left', 'text-wrap']"
                      v-else-if="item.body.type === 'image'">
                      <button @click="abrirEnlace(item.url)">
                        <img class="rounded-xxl elevation-5 row-pointer" :src="item.url" contain
                          lazy-src="https://picsum.photos/id/11/10/6" :aspect-ratio="16 / 9" height="150" />
                      </button>
                      <div v-if="item.body.image?.caption" class="mt-2">
                        <p>{{ item.body.image?.caption }}</p>
                      </div>
                    </v-list-item-title>

                    <v-list-item-title :class="[colorChat(item.type), 'text-left', 'text-wrap']"
                      v-else-if="item.body.type === 'document'">
                      <v-btn @click="abrirEnlace(item.url)" class="ma-2" outlined icon color="green lighten-2">
                        <v-icon>mdi-file-pdf-box</v-icon>
                      </v-btn>
                      <div v-if="item.body.document?.caption || item.body.image?.caption">
                        <p class="mt-2">{{ item.body.document?.caption || item.body.image?.caption }}</p>
                      </div>
                    </v-list-item-title>

                    <v-list-item-title :class="[colorChat(item.type), 'text-left', 'text-wrap']"
                      v-else-if="item.body.type === 'reaction'">
                      {{ item.body.reaction.emoji }}
                    </v-list-item-title>

                    <v-list-item-title :class="[colorChat(item.type), 'text-left', 'text-wrap']"
                      v-else-if="item.body.type === 'video'">
                      <button @click="abrirEnlace(item.url)">
                        <div class="secondary rounded-pill d-inline pa-2 mt-3 deep-purple accent-4 white--text">
                          <v-icon left>mdi-movie</v-icon> Video - Multimedia
                        </div>
                      </button>
                      <div v-if="item.body.video?.caption" class="mt-2">
                        <p>{{ item.body.video?.caption }}</p>
                      </div>
                    </v-list-item-title>

                    <v-list-item-title :class="[colorChat(item.type), 'text-left', 'text-wrap']"
                      v-else-if="item.body.type === 'audio'">
                      <v-btn class="mx-2" fab dark small color="green" @click="playSound(item.url)">
                        <v-icon dark>mdi-play</v-icon>
                      </v-btn>
                      <v-btn class="mx-2" fab dark small color="red" @click="stopSound()">
                        <v-icon dark>mdi-stop</v-icon>
                      </v-btn>
                    </v-list-item-title>

                    <v-list-item-title v-else :class="[colorChat(item.type), 'text-left', 'text-wrap']">
                      <template v-if="Array.isArray(containsURL(extraerTextoMensaje(item)))">
                        <v-btn v-for="url in containsURL(extraerTextoMensaje(item))" :key="url"
                          @click="abrirEnlace(url)" text
                          :color="url === 'Link no confiable' ? 'white' : 'green darken-2'">
                          <v-icon large :color="url === 'Link no confiable' ? 'red' : 'green darken-2'">
                            {{ url === "Link no confiable" ? "mdi-alert-circle" : "mdi-web" }}
                          </v-icon>
                          <template v-if="url === 'Link no confiable'">
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <span v-bind="attrs" v-on="on" class="red--text">Link no confiable</span>
                              </template>
                              <span>Este enlace no es confiable. Procede con precaución.</span>
                            </v-tooltip>
                          </template>
                          <template v-else>
                            <span class="green--text ml-1">Link Confiable</span>
                          </template>
                        </v-btn>
                      </template>
                      <template v-else>
                        {{ extraerTextoMensaje(item) }}
                      </template>
                    </v-list-item-title>

                    <v-list-item-title class="text-right caption mt-2 d-flex justify-end align-center">
                      <v-btn icon color="blue" @click="seleccionarParaResponder(item)" x-small class="mr-2"
                        title="Responder">
                        <v-icon>mdi-reply</v-icon>
                      </v-btn>

                      <v-btn :disabled="['audio', 'sticker', 'button', 'reaction'].includes(item.body.type)" icon
                        color="amber" @click="copiarTexto(extraerTextoMensaje(item))" x-small class="mr-3"
                        title="Copiar texto">
                        <v-icon>mdi-content-copy</v-icon>
                      </v-btn>

                      <v-chip v-if="item.type" x-small color="orange" class="mr-3" outlined>
                        {{ item.type }}
                      </v-chip>

                      <v-chip small color="green" outlined>
                        {{ item.usuario || usuarioW }} - {{ fechaConvertirFirebase(item.timestamp) }}
                      </v-chip>
                    </v-list-item-title>

                    <v-divider color="green" class="mt-2"></v-divider>
                  </v-list-item-content>
                </v-list-item>
              </div>
            </v-card>
          </v-col>
        </v-row>

        <v-divider color="grey" class="mt-5"></v-divider>
        <v-row v-if="celular">
          <v-col cols="4" class="p-3 mt-5 text-center">
            <v-autocomplete class="p-3 text-end" v-model="plantilla" :items="plantillas" item-text="contenido"
              item-value="plantilla" label="Plantilla rápida" outlined dense chips small-chips></v-autocomplete>
          </v-col>

          <v-col cols="8" class="mt-3 d-flex flex-column">

            <v-scale-transition>
              <div v-if="mensajeAResponder"
                class="blue-grey darken-4 pa-2 mb-2 rounded d-flex align-center justify-space-between"
                style="border-left: 4px solid #4CAF50;">
                <div class="text-truncate mr-2" style="max-width: 90%;">
                  <small class="green--text text--lighten-2">Respondiendo a:</small><br>
                  <span class="white--text caption">
                    <v-icon x-small color="white" class="mr-1">mdi-reply</v-icon>
                    {{ extraerTextoMensaje(mensajeAResponder) || 'Multimedia' }}
                  </span>
                </div>
                <v-btn icon small color="red" @click="mensajeAResponder = null">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </div>
            </v-scale-transition>

            <v-row>
              <v-col cols="11">
                <v-textarea v-model="mensaje" label="Escribe tu mensaje..." multi-line rows="3" color="green" auto-grow
                  outlined hide-details @keydown.enter.exact.prevent="conversar"></v-textarea>
              </v-col>
              <v-col cols="1" class="d-flex align-center justify-center">
                <v-btn @click="conversar" icon outlined color="green" :disabled="!mensaje && !plantilla">
                  <v-icon>mdi-send</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-switch :disabled="!estadoWhatsapp" v-model="switchTiempoReal"
          :label="switchTiempoReal ? 'Abierto - Atención Whatsapp' : 'Cerrado - Atención Whatsapp'" color="green"
          @change="listenToMessages"></v-switch>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import store from "@/store";
import { db } from "@/firebase/config.js";
import { FBenviarMensajeWhatsapp } from "@/components/Ventas/Tableros/whatsapp/conversarGeneral.js";
import { FBaccionesWhatsapp } from "@/components/Ventas/Tableros/whatsapp/acciones.js";
import { FBenvioMasivo } from "@/components/Mercadeo/Tableros/whatsapp/masivo.js";
import Editar from "./wappEditar.vue";
import VermillionAudio from "@/assets/notificaciones/Vermillion.mp3";
import ConfiguracionWhatsapp from "./configuracion.vue";
import NuevoUsuario from "./nuevoUsuario.vue";
import CrearOportunidadPNatural from "../../Prospectos/agregaOportunidaNatural.vue";

// Audio general para notificaciones de mensajes entrantes
const notificacionCampana = new Audio(VermillionAudio);

export default {
  props: ["datos", "correo"],
  components: {
    Editar,
    ConfiguracionWhatsapp,
    NuevoUsuario,
    CrearOportunidadPNatural,
  },
  data() {
    return {
      rolPrueba: store.state.user[2][0].data.empleado,
      dialog: false,
      switchTiempoReal: false,
      items: [],
      mensaje: "",
      unsubscribe: null,
      selectedItem: null,
      estadoWhatsapp: false,
      audioMensajeActual: null, // Controla las notas de voz
      masivoWhatsapp: false,
      plantilla: "",
      mensajeAResponder: null, // Guarda el objeto del mensaje seleccionado para responder
      plantillas: [
        { plantilla: "autorizacion_inicio", contenido: "¡Hola! 😊 Estamos entusiasmados de estar en contacto contigo..." },
        { plantilla: "bienvenida_es", contenido: "¡Hola! 👋 Gracias por contactarnos por WhatsApp. En breve estaremos contigo..." },
        { plantilla: "continuar_1", contenido: "Gracias por tu espera, continuamos?" },
        { plantilla: "continuar_2", contenido: "Si tienes alguna otra duda con gusto estaremos atentos. 🥸" },
        { plantilla: "tb_p01", contenido: "¡Te invitamos a explorar nuestro Catálogo en línea! 🛍" },
        { plantilla: "recepcion_pedido_tienda01", contenido: "Te saluda todo el equipo de TiendaBeraca.com Hemos recibido tu pedido..." },
        { plantilla: "iniciar_conversacion_tb_01", contenido: "Requerimos informarte..." },
      ],
    };
  },
  computed: {
    chatActivo() {
      return this.selectedItem !== null ? this.items[this.selectedItem] : null;
    },
    celular() {
      return this.chatActivo ? this.chatActivo.numero : null;
    },
    historialMensajes() {
      return this.chatActivo ? this.chatActivo.contenido.messages : [];
    },
    usuarioW() {
      return this.chatActivo ? this.chatActivo.contenido.usuario : null;
    },
    empresa() {
      return this.chatActivo ? this.chatActivo.contenido.empresa : "";
    },
    seguimiento() {
      return this.chatActivo ? this.chatActivo.contenido.seguimiento : false;
    },
    alertaGeneral() {
      return this.items.some(item => item.contenido && item.contenido.mensajePendiente);
    }
  },
  watch: {
    // Escucha alertas generales para reproducir el timbre
    alertaGeneral(nuevoValor) {
      if (nuevoValor) {
        this.reproducirNotificacion();
      }
    },
    // Al cambiar de chat, limpiar la respuesta actual y hacer scroll
    selectedItem() {
      this.mensajeAResponder = null;
      this.$nextTick(() => {
        this.scrollToBottom();
      });
    },
    // Cuando el historial del chat actual crece, hacer scroll
    historialMensajes() {
      this.$nextTick(() => {
        this.scrollToBottom();
      });
    }
  },
  mounted() {
    this.scrollToBottom();
  },
  beforeDestroy() {
    this.stopListening();
    this.stopSound();
  },
  methods: {
    async masivos() {
      this.masivoWhatsapp = true;
      try {
        const resultMasivo = await FBenvioMasivo();
        console.log(resultMasivo);
      } finally {
        this.masivoWhatsapp = false;
      }
    },

    abrirEnlace(enlace) {
      if (enlace && enlace !== "Link no confiable") {
        window.open(enlace, "_blank");
      }
    },

    // Reproducción de notas de voz recibidas
    playSound(soundUrl) {
      this.stopSound(); // Detiene cualquier audio previo antes de iniciar uno nuevo
      if (soundUrl) {
        this.audioMensajeActual = new Audio(soundUrl);
        this.audioMensajeActual.play().catch(e => console.error("Error al reproducir audio", e));
      }
    },

    stopSound() {
      if (this.audioMensajeActual) {
        this.audioMensajeActual.pause();
        this.audioMensajeActual.currentTime = 0;
        this.audioMensajeActual = null;
      }
    },

    scrollToBottom() {
      const container = this.$refs.scrollContainer;
      if (container) {
        container.scrollTop = container.scrollHeight;
      }
    },

    async datosActualizar(llega, clave) {
      const json = { numero: this.celular, accion: "editar", clave: clave, valor: llega };
      await FBaccionesWhatsapp(json);
    },

    async acciones(accion) {
      const json = { numero: this.celular, accion: accion };
      await FBaccionesWhatsapp(json);
    },

    fechaConvertirFirebase(timestamp) {
      if (!timestamp || !timestamp.seconds) return "Fecha inválida";
      return new Date(timestamp.seconds * 1000).toLocaleString();
    },

    // Extrae de forma segura el texto de cualquier tipo de mensaje
    extraerTextoMensaje(item) {
      if (!item || !item.body) return "";
      return item.body.text?.body || item.body.image?.caption || item.body.video?.caption || item.body.document?.caption || item.body;
    },

    // NUEVA FUNCIONALIDAD: Establece el mensaje a responder
    seleccionarParaResponder(item) {
      this.mensajeAResponder = item;
    },

    async conversar() {
      if (!this.mensaje && !this.plantilla) return;

      const jsonSale = {
        telefonoSelect: this.celular,
        contacto: this.usuarioW,
        doliente: this.rolPrueba,
        correoSelect: this.correo,
        mensaje: this.mensaje,
        plantilla: this.plantilla,
        // Incluimos el ID del mensaje original si estamos respondiendo
        contextId: this.mensajeAResponder ? this.mensajeAResponder.body.id : null
      };

      const result = await FBenviarMensajeWhatsapp(jsonSale);
      if (result) {
        this.mensaje = "";
        this.plantilla = "";
        this.mensajeAResponder = null; // Limpiar respuesta al enviar
        this.scrollToBottom();
      } else {
        this.mensaje = "Falló envio. Intenta de nuevo.";
      }
    },

    listenToMessages(chat) {
      if (chat === "ok") this.switchTiempoReal = false;

      if (this.switchTiempoReal) {
        const docRef = db.collection("cf-whatsapp");

        this.unsubscribe = docRef.onSnapshot((querySnapshot) => {
          querySnapshot.docChanges().forEach((change) => {
            const id = change.doc.id;
            const data = change.doc.data();

            if (change.type === "added") {
              this.items.push({ numero: id, contenido: data });
            } else if (change.type === "modified") {
              const index = this.items.findIndex((item) => item.numero === id);
              if (index !== -1) {
                // Actualiza conservando la reactividad
                this.$set(this.items, index, { numero: id, contenido: data });
              }
            } else if (change.type === "removed") {
              this.items = this.items.filter((item) => item.numero !== id);
            }
          });

          this.items.sort((a, b) => b.contenido.mensajePendiente - a.contenido.mensajePendiente);
        });
      } else {
        this.stopListening();
      }
    },

    stopListening() {
      if (this.unsubscribe) {
        this.unsubscribe();
        this.unsubscribe = null;
        this.reiniciar();
      }
    },

    reiniciar() {
      this.switchTiempoReal = false;
      this.items = [];
      this.mensaje = "";
      this.selectedItem = null;
      this.mensajeAResponder = null;
    },

    async copiarTexto(texto) {
      if (navigator.clipboard && texto) {
        try {
          await navigator.clipboard.writeText(texto);
        } catch (error) {
          console.error("Error copiando texto", error);
        }
      }
    },

    reproducirNotificacion() {
      notificacionCampana.play().catch(() => { });
    },

    colorChat(tipo) {
      return tipo === undefined ? "custom-backgroundInterno" : "custom-background";
    },

    estadoW(estado) {
      this.estadoWhatsapp = estado;
    },

    containsURL(str) {
      if (!str || typeof str !== 'string') return str;
      const regex = /(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/|www\.)[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/g;
      const matches = str.match(regex);

      if (!matches || matches.length === 0) return str;

      const safeDomains = [
        "tiendaberaca.com", "drive.google.com", "google.com", "facebook.com", "whatsapp.com", // ...agrega los tuyos
      ];

      return matches.map((url) => {
        try {
          const domain = new URL(url).hostname;
          return safeDomains.includes(domain) ? url : "Link no confiable";
        } catch (e) {
          return "Link no confiable";
        }
      });
    },
  }
};
</script>

<style scoped>
.message-scroll {
  max-height: 400px;
  overflow-y: auto;
}

.custom-background {
  background-color: #fff7a3;
  border-radius: 10px;
  padding: 10px;
  color: rgb(58, 58, 58);
  margin-bottom: 5px;
}

.custom-backgroundInterno {
  background-color: #a1ffa5;
  border-radius: 10px;
  padding: 10px;
  color: rgb(0, 58, 0);
  margin-bottom: 5px;
}

.row-pointer {
  cursor: pointer;
}
</style>